import { Link } from 'react-router-dom';

export default function ServicesCTA() {
  return (
    <section className="bg-amber-500 py-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0F172A] mb-6 leading-tight">
          Let Your Systems Do the Work
        </h2>
        <p className="text-[#0F172A]/70 text-lg leading-relaxed mb-10 max-w-xl mx-auto">
          Schedule a free demo and we&apos;ll build your automation blueprint—
          showing exactly how your business would run on autopilot.
        </p>
        <Link
          to="/"
          className="whitespace-nowrap inline-block bg-[#0F172A] text-white font-bold text-base px-12 py-4 rounded-lg hover:bg-slate-800 transition-colors cursor-pointer"
        >
          Book a Demo
        </Link>
      </div>
    </section>
  );
}
